<!-- 添加访客接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KKN885S",
          "carNo": "粤YGW982",
          "owner": "李四",
          "phone": "13596156884",
          "reason": "访友",
          "visitFrom": "20161214163930",
          "visitTo": "20161215163930",
          "specialCarTypeId": 154
        },
        responseCode: {
          "data": {
            "visitorId": 151
          }, "message": "业务成功", "resultCode": 0, "status": 1
        }, infoData: {
          explain: "第三方接入系统请求智慧停车开放平台添加某个访客车辆",
          t_url: this.commonUrls.test + "addVisitorCarNew",
          p_url: this.commonUrls.prod + "addVisitorCarNew",
          precondition: {
            preData: "对接接口-",
            link:  "添加特殊车辆类型",
            url: "addSpecialCarType",
            endData: "，用于获取添加访客所需要的specialCarTypeId（如已有请忽略）"
          },
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号'},
              {info1: 'carNo', info2: '是', info3: 'String', info4: '车牌'},
              {info1: 'owner', info2: '是', info3: 'String', info4: '车主'},
              {
                info1: 'specialCarTypeId',
                info2: '是',
                info3: 'Long',
                info4: '特殊车辆类型id，仅支持通过新特殊车辆类型（addSpecialCarType）创建的特殊车辆类型返回的specialCarTypeId，'
              },
              {info1: 'visitFrom', info2: '是', info3: 'String', info4: '预计来访开始时间，格式为：yyyyMMddHHmmss'},
              {info1: 'visitTo', info2: '是', info3: 'String', info4: '预计来访结束时间，格式为: yyyyMMddHHmmss'},
              {info1: 'phone', info2: '否', info3: 'String', info4: '电话号码'},
              {info1: 'reason', info2: '否', info3: 'String', info4: '来访原因'}
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'visitorId', info2: '是', info3: 'Long', info4: '访客Id，用于取消访客'}
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/visitor/addVisitorCarNew.vue